export default {
    name: "Confirm",
    title: "Confirm",
    icon: "mdi-comment-question-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            message: "Confirm?",
            childAction1: [],
            childAction2: [],
        };
    },
};